/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Address for manual place creation (fallback)
 * @export
 * @interface CreateStopDtoAddress
 */
export interface CreateStopDtoAddress {
    /**
     * 
     * @type {string}
     * @memberof CreateStopDtoAddress
     */
    addressLine1?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStopDtoAddress
     */
    addressLine2?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStopDtoAddress
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStopDtoAddress
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStopDtoAddress
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStopDtoAddress
     */
    countryName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStopDtoAddress
     */
    countryCode?: string;
}

/**
 * Check if a given object implements the CreateStopDtoAddress interface.
 */
export function instanceOfCreateStopDtoAddress(value: object): value is CreateStopDtoAddress {
    return true;
}

export function CreateStopDtoAddressFromJSON(json: any): CreateStopDtoAddress {
    return CreateStopDtoAddressFromJSONTyped(json, false);
}

export function CreateStopDtoAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateStopDtoAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'addressLine1': json['addressLine1'] == null ? undefined : json['addressLine1'],
        'addressLine2': json['addressLine2'] == null ? undefined : json['addressLine2'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'countryName': json['countryName'] == null ? undefined : json['countryName'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
    };
}

  export function CreateStopDtoAddressToJSON(json: any): CreateStopDtoAddress {
      return CreateStopDtoAddressToJSONTyped(json, false);
  }

  export function CreateStopDtoAddressToJSONTyped(value?: CreateStopDtoAddress | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'addressLine1': value['addressLine1'],
        'addressLine2': value['addressLine2'],
        'city': value['city'],
        'state': value['state'],
        'postalCode': value['postalCode'],
        'countryName': value['countryName'],
        'countryCode': value['countryCode'],
    };
}

